import React from 'react';
import GenericCard from '../generic-card';
import { APP_CONFIG, HERO, FULL_WIDTH, SUB_HERO, MINIMAL_HERO } from '../../app-constants';

export const formatArticleContent = (article, imageBaseLink, layoutMode) => {
  const imgSrc = `${imageBaseLink}/${article.articleId}.jpg`;
  const imgClass = 'card-img-top';
  const linkSrc = `${APP_CONFIG.reactBasePath}/articles/${article.articleId}`;
  return {
    img: { imgSrc, imgClass },
    data: { title: article.title, summary: article.summary, articleId: article.articleId, linkSrc, layoutMode },
    metaData: { source: article.source, createdDate: article.createdDate, readingTime: article.readingTime },
  };
};

export const articleClass = (layoutMode, customClass = 'col-sm-12') => {
  let className;
  switch (layoutMode) {
    case HERO:
      className = `col-sm-12 ${HERO}`;
      break;
    case FULL_WIDTH:
      className = `col-sm-12 ${FULL_WIDTH}`;
      break;
    case SUB_HERO:
      className = `col-sm-6 ${SUB_HERO}`;
      break;
    case MINIMAL_HERO:
      className = `${customClass} ${MINIMAL_HERO}`;
      break;
    default:
      className = 'col-sm-4';
  }
  return className;
};

const Articles = (props) => {
  const { articles, imageBaseLink, customLayoutMode, customClass } = props;
  return (
    <div className="articles grid-12px row">
      {articles.map((article) => {
        const layoutMode = customLayoutMode || article.layoutMode;
        const content = formatArticleContent(article, imageBaseLink, layoutMode);
        return (
          <div className={`${articleClass(layoutMode, customClass)} article`} key={`div-${article.articleId}`} >
            <GenericCard headerTitle={content.metaData} content={content} cardClass="border-0" />
          </div>
        );
      })
      }
    </div>
  );
};

export default Articles;
